import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { LEADERSHIP } from "../data";

export default function LeadershipPage() {
  return (
    <>
      <PageHeader
        overline="05 — Stewardship"
        lines={["The people behind", "the platform."]}
        subtitle="Financial experience and execution — the leadership steering Ashutosh Capital into its Green Finance chapter."
      />

      <section className="py-20 md:py-28 bg-bg" data-testid="leadership-grid">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20">
          <div className="grid md:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
            {LEADERSHIP.map((m, i) => (
              <Reveal key={m.name} delay={i * 0.08}>
                <article className="group relative bg-surface h-full flex flex-col" data-testid={`leader-${i}`}>
                  <div className="relative overflow-hidden aspect-[4/5] bg-surface2">
                    <img src={m.photo} alt={m.name} className="img-grayscale w-full h-full object-cover object-top scale-105 group-hover:scale-110 transition-transform duration-1000" />
                    <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
                    <div className="absolute bottom-0 left-0 p-6">
                      <div className="overline text-brand-green">{m.meta}</div>
                    </div>
                  </div>
                  <div className="p-8 flex flex-col flex-1">
                    <h3 className="font-heading font-bold text-ink text-xl tracking-tight flex items-center gap-2">
                      {m.name}
                      <span className="inline-block w-1.5 h-4 bg-brand-green opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </h3>
                    <div className="mt-1 overline text-ink/40">{m.role}</div>
                    <ul className="mt-6 space-y-3">
                      {m.points.map((p) => (
                        <li key={p} className="flex items-start gap-3 font-body text-sm text-ink/60">
                          <span className="mt-1.5 w-1.5 h-1.5 bg-brand-green shrink-0" />{p}
                        </li>
                      ))}
                    </ul>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
